import { render, staticRenderFns } from "./Documenti.vue?vue&type=template&id=b83e612a"
import script from "./Documenti.vue?vue&type=script&lang=js"
export * from "./Documenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports